// Angular
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// NgBootstrap
import {
    NgbDropdownModule,
    NgbTooltipModule,
    NgbNavModule,
    NgbRatingModule,
    NgbProgressbarModule,
} from '@ng-bootstrap/ng-bootstrap';
// Perfect Scrollbar
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
// Core module
import { CoreModule } from '../../core/core.module';
// CRUD Partials
// Layout partials
import {
    ContextMenu2Component,
    ContextMenuComponent,
    LanguageSelectorComponent,
    NotificationComponent,
    QuickActionComponent,
    QuickPanelComponent,
    ScrollTopComponent,
    SearchDefaultComponent,
    SearchDropdownComponent,
    SearchResultComponent,
    SplashScreenComponent,
    StickyToolbarComponent,
    Subheader1Component,
    Subheader2Component,
    Subheader3Component,
    Subheader4Component,
    Subheader5Component,
    SubheaderSearchComponent,
    UserProfile2Component,
    UserProfile3Component,
    UserProfileComponent,
} from './layout';
// General
import { NoticeComponent } from './content/general/notice/notice.component';
import { PortletModule } from './content/general/portlet/portlet.module';
// Errpr
import { ErrorComponent } from './content/general/error/error.component';
// Extra module
// SVG inline
import { InlineSVGModule } from 'ng-inline-svg';
import { CartComponent } from './layout/topbar/cart/cart.component';
// Material

// primeng modules
import { TableModule } from 'primeng/table';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import {TooltipModule} from 'primeng/tooltip';
import {ProgressSpinnerModule} from "primeng/progressspinner";
import { ConfirmationService } from 'primeng/api';

import { NgxPermissionsModule } from 'ngx-permissions';
import { IMaskModule } from 'angular-imask';
import {TimeAgoPipe} from '../../mbs/pipes/time-ago/time-ago.pipe';

@NgModule({
    providers: [ConfirmationService],
    declarations: [
        ScrollTopComponent,
        NoticeComponent,

        // topbar components
        ContextMenu2Component,
        ContextMenuComponent,
        QuickPanelComponent,
        ScrollTopComponent,
        SearchResultComponent,
        SplashScreenComponent,
        StickyToolbarComponent,
        Subheader1Component,
        Subheader2Component,
        Subheader3Component,
        Subheader4Component,
        Subheader5Component,
        SubheaderSearchComponent,
        LanguageSelectorComponent,
        NotificationComponent,
        QuickActionComponent,
        SearchDefaultComponent,
        SearchDropdownComponent,
        UserProfileComponent,
        UserProfile2Component,
        UserProfile3Component,
        CartComponent,

        ErrorComponent,
        TimeAgoPipe,
    ],
    exports: [
        // common
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        IMaskModule,

        PortletModule,

        ScrollTopComponent,
        NoticeComponent,

        // topbar components
        ContextMenu2Component,
        ContextMenuComponent,
        QuickPanelComponent,
        ScrollTopComponent,
        SearchResultComponent,
        SplashScreenComponent,
        StickyToolbarComponent,
        Subheader1Component,
        Subheader2Component,
        Subheader3Component,
        Subheader4Component,
        Subheader5Component,
        SubheaderSearchComponent,
        LanguageSelectorComponent,
        NotificationComponent,
        QuickActionComponent,
        SearchDefaultComponent,
        SearchDropdownComponent,
        UserProfileComponent,
        UserProfile2Component,
        UserProfile3Component,
        CartComponent,

        ErrorComponent,

        // ngprime modules
        TableModule,
        ConfirmDialogModule,
        DialogModule,
        DynamicDialogModule,
        TooltipModule,

        // NgxPermissionsModule
        NgxPermissionsModule,

        // Ngb Bootstrap
        NgbRatingModule,
        NgbDropdownModule,
        NgbProgressbarModule,
        NgbTooltipModule,
        TimeAgoPipe,
    ],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        IMaskModule,
        PerfectScrollbarModule,
        InlineSVGModule,
        CoreModule,
        PortletModule,

        // angular material modules

        // ngprime modules
        TableModule,
        ConfirmDialogModule,
        DialogModule,
        DynamicDialogModule,
        TooltipModule,
        ProgressSpinnerModule,
        // NgxPermissions
        NgxPermissionsModule,

        // ng-bootstrap modules
        NgbDropdownModule,
        NgbNavModule,
        NgbTooltipModule,
        NgbRatingModule,
        NgbProgressbarModule,
        NgbTooltipModule,
    ],
})
export class PartialsModule {}
